export default class PrintableForm {
	private elementForm: HTMLElement;
	private elementPrint: HTMLElement;
	private elementSuccess: HTMLElement;

	/**
	 * Serialize all form data into a JSON string
	 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
	 * @param {HTMLFormElement} form The form to serialize
	 * @returns {String} The serialized form data
	 */
	static serializeJSON = (form: HTMLFormElement): string => {
		let obj = {};
		Array.prototype.slice.call(form.elements).forEach(function (field) {
			if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
			if (field.type === 'select-multiple') {
				let options = [];
				Array.prototype.slice.call(field.options).forEach(function (option) {
					if (!option.selected) return;
					options.push(option.value);
				});
				if (options.length) {
					obj[field.name] = options;
				}
				return;
			}
			if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
			obj[field.name] = field.value;
		});
		return JSON.stringify(obj, null, 2);
	}

	private storeFormData = () => {
		// When the form is submitted save the data so we can display it on the success page.
		// Because Shopify does not allow for access to submission
		// Shopify adds an event handler to fire a RECAPTCHA and it has it's own submit button
		let someData = PrintableForm.serializeJSON(this.elementForm as HTMLFormElement);
		localStorage.setItem('clarityAloftData', someData);
	}
	private printHandler = (event) => {
		event.preventDefault();
		window.print();
	}
	private cleanUpResults = (result: string) => {
		let cleanResults = null;
		if (result !== 'form_type' && result !== 'utf8') {
			cleanResults = /contact\[(.+)\]/.exec(result);
			if (cleanResults !== null) {
				cleanResults = cleanResults[1].replace(/_/g, " ").toUpperCase();
			}
		}
		return cleanResults;
	}
	constructor() {
		this.elementForm = document.getElementById("contact_form");
		this.elementPrint = document.getElementById("contact-form-print");
		this.elementSuccess = document.getElementById("form-submission-information");

		if (this.elementForm) {
			this.elementForm.addEventListener('change', this.storeFormData);
		}
		if (this.elementPrint) {
			this.elementPrint.addEventListener('click', this.printHandler);
		}
		if (this.elementSuccess) {
			let json = localStorage.getItem('clarityAloftData');

			if (json !== null && json !== undefined) {
				const parsedJSON = JSON.parse(json);
				let html = '<h3>Form Submission Information</h3>';
				let props = '';
				for (let prop in parsedJSON) {
					let fieldName = this.cleanUpResults(prop);
					if (fieldName !== null ) {
						props += '<strong>' + fieldName + '</strong>: ' + parsedJSON[prop] + '<br/>';
					}
				}
				html += '<p>' + props + '</p>';

				this.elementSuccess.innerHTML = html;
			}
		}
	}
}
